import React from "react";
import { Calendar, Mail } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

interface NavigationTabsProps {
  activeTab: "news-today" | "emails" | "settings";
  onTabChange: (tab: "news-today" | "emails" | "settings") => void;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({ onTabChange }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (tab: "news-today" | "emails" | "settings") => {
    onTabChange(tab);
    switch (tab) {
      case "news-today":
        navigate("/dashboard/news-today");
        break;
      case "emails":
        navigate("/dashboard/newsletter");
        break;
    }
  };

  return (
    <>
      <div className="relative">
        {/* Background gradient */}

        {/* Dot pattern overlay */}

        {/* Content */}
        <div className="relative z-10">
          <div className="max-w-2xl mx-auto w-full px-4 pt-4">
            <div className="flex gap-3">
              <div className="relative">
                <div
                  className={`absolute inset-0 bg-black rounded-t-lg 
                  ${
                    location.pathname === "/dashboard/news-today"
                      ? "opacity-100"
                      : "opacity-0"
                  }`}
                />
                <button
                  className={`relative px-6 py-3 font-medium text-sm rounded-t-lg transition-all 
                    ${
                      location.pathname === "/dashboard/news-today"
                        ? "bg-white border-gray-200 border-2 border-b-0 text-black"
                        : "bg-black/5 hover:bg-black/10 text-gray-600"
                    }`}
                  onClick={() => handleTabChange("news-today")}
                >
                  <div className="flex items-center gap-2">
                    <Calendar
                      size={18}
                      className={`${
                        location.pathname === "/dashboard/news-today"
                          ? "text-indigo-600"
                          : ""
                      }`}
                    />
                    <span className="relative">News Today</span>
                  </div>
                </button>
              </div>

              <div className="relative">
                <div
                  className={`absolute inset-0 bg-black rounded-t-lg 
                  ${
                    location.pathname.startsWith("/dashboard/newsletter")
                      ? "opacity-100"
                      : "opacity-0"
                  }`}
                />
                <button
                  className={`relative px-6 py-3 font-medium text-sm rounded-t-lg transition-all duration-200
                    ${
                      location.pathname.startsWith("/dashboard/newsletter")
                        ? "bg-white border-gray-200 border-2 border-b-0 text-black"
                        : "bg-black/5 hover:bg-black/10 text-gray-600"
                    }`}
                  onClick={() => handleTabChange("emails")}
                >
                  <div className="flex items-center gap-2">
                    <Mail
                      size={18}
                      className={`${
                        location.pathname.startsWith("/dashboard/newsletter")
                          ? "text-indigo-600"
                          : ""
                      }`}
                    />
                    <span className="relative">Emails</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className="border-b-2 border-gray-200"></div>
        </div>
      </div>
    </>
  );
};

export default NavigationTabs;
